import React from "react";
import { AuthRoles } from "components/auth";

export const EmployeesConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/employees`,
      component: React.lazy(() => import("./Employees")),
    },
  ],
};
